import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProvidersService } from "../../../../_services/providers.service";
import { BreadcrumbService } from "../../../../_services/breadcrumb.service";

@Component({
  selector: "app-provider-ai-usage",
  templateUrl: "./provider-ai-usage.component.html",
  styleUrls: ["./provider-ai-usage.component.css"],
})
export class ProviderAiUsageComponent implements OnInit {
  entityUuid: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private service: ProvidersService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    const numericId = this.route.snapshot.parent?.params?.id;
    this.service.getProvider(numericId).subscribe((data) => {
      this.entityUuid = data.result.uuid;
      this.breadcrumbService.changeBreadcrumbs(
        this.breadcrumbService.setForProvider(data.result, "ai-usage")
      );
    });
  }
}
